<template>
    <v-card outlined class="login-screen">
        <v-card-text>
            <div class="login-logo">
                <img src="/images/logo/denzapine-logo-large.png" alt="denzapine-logo" />
            </div>
            <div class="login-title">
                <h1>{{ t('login::page.password.reset.title') }}</h1>
            </div>

            <p class="text-center">
                {{ t('login::password.link.sent.message') }}
            </p>

            <div class="d-flex flex-wrap justify-content-between align-items-center mt-10">
                <v-btn class="mb-7" block large color="primary" rounded @click="$emit('cancel')"
                    >{{ t('login::password.link.sent.button') }}
                </v-btn>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'RecoveryLinkSent',
};
</script>

<style scoped></style>
